import styled from 'styled-components'

export const StyledTradeFlow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  font-weight: 500;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textTitle};
`
